import { render } from "./EquivalentMedicamentModal.vue?vue&type=template&id=2ad7dca0&scoped=true"
import script from "./EquivalentMedicamentModal.vue?vue&type=script&lang=js"
export * from "./EquivalentMedicamentModal.vue?vue&type=script&lang=js"

import "./EquivalentMedicamentModal.vue?vue&type=style&index=0&id=2ad7dca0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ad7dca0"]])

export default __exports__